<!-- footer  -->
   <footer class="text-center footer-text pb-3">&copy; {{ currentYear }} Superior Court of California, County of San Bernardino. All Rights Reserved</footer>